/**
 * @generated SignedSource<<770a83a88c64b7c9720065cd8a5442d6>>
 * @relayHash 357dca516a03b4d930fdd755265ddd4c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID bed97ac834892e99a303950bf7b40dabcc9ece041755887b2053ef4eb8dec3db

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type SubspaceMenuListQuery$variables = {
  cloudId: string;
  projectKey: string;
};
export type SubspaceMenuListQuery$data = {
  readonly jira: {
    readonly jiraProjectByKey: {
      readonly " $fragmentSpreads": FragmentRefs<"SubspaceMenuList">;
    };
  };
};
export type SubspaceMenuListQuery = {
  response: SubspaceMenuListQuery$data;
  variables: SubspaceMenuListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectKey"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "projectKey"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "SubspaceMenuListQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "args": (v1/*: any*/),
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "jiraProjectByKey",
                "plural": false,
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "SubspaceMenuList"
                  }
                ]
              },
              "action": "THROW",
              "path": "jira.jiraProjectByKey"
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SubspaceMenuListQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProjectByKey",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "ClientExtension",
                "selections": [
                  {
                    "concreteType": "JiraSubspaceConnection_CSE",
                    "kind": "LinkedField",
                    "name": "subspaces_cse",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraSubspaceEdge_CSE",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "JiraSubspace_CSE",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "name"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "subspaceUrl"
                              },
                              (v2/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "bed97ac834892e99a303950bf7b40dabcc9ece041755887b2053ef4eb8dec3db",
    "metadata": {},
    "name": "SubspaceMenuListQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "65b8e540042d1729ab8324feed40f7dd";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
